import { render, staticRenderFns } from "./edit-company-dialog.vue?vue&type=template&id=7ddc33ee&scoped=true"
import script from "./edit-company-dialog.vue?vue&type=script&lang=js"
export * from "./edit-company-dialog.vue?vue&type=script&lang=js"
import style0 from "./edit-company-dialog.vue?vue&type=style&index=0&id=7ddc33ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddc33ee",
  null
  
)

export default component.exports